import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { Certification, CityCertification, CityCertificationResume, EvidenceAbntType } from 'app/shared/objects/certification';
import {
  CityDataSource,
  GlobalBenchmarkCity,
  IndicatorSearchFilter,
  SolutionPerCityIndicator
} from 'app/shared/objects/cities';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class CityProfileService {

  constructor(
    private http: HttpClient,
    private authService: AuthService) {
  }

  getCityProfileIndicatorHistory(cityId: string, data?: IndicatorSearchFilter): Promise<any> {
    return this.http.get(environment.apiURL + '/restricted/cityProfileHistory/' + cityId)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  getIndicatorHistory(cityId: string, data?: IndicatorSearchFilter): Promise<any> {
    return this.http.post(environment.apiURL + '/restricted/cityProfile/indicatorHistory/' + cityId, data)
      .toPromise()
      .then(response => {
        if (response[ 'success' ])
          return response;
        else
          return null;
      })
      .catch(error => {
        console.log(`Error: getIndicatorHistory`);
        return null;
      });
  }

  getDataSources(): Promise<CityDataSource[]> {
    return this.http.get(environment.apiURL + '/restricted/cityProfile/dataSources')
      .toPromise()
      .then(response => {
        if (response[ 'success' ])
          return response;
        else
          return null;
      })
      .catch(error => {
        console.log(`Error: getDataSources`);
        return null;
      });
  }

  saveProfileSingleIndicatorData(cityId: string, year: string, data: any): Promise<any> {
    return this.http.post(`${environment.apiURL}/restricted/cityProfile/saveProfileSingleItem/${cityId}/${year}`, data)
      .toPromise()
      .then(response => {
        if (response[ 'success' ])
          return response;
        else
          return null;
      })
      .catch(error => {
        return null;
      });
  }

  deleteProfileSingleIndicatorData(cityId: string, year: string, data: any): Promise<any> {
    return this.http.post(`${environment.apiURL}/restricted/deleteIndicatorFromProfile/${cityId}/${year}`, data)
      .toPromise()
      .then(response => {
        if (response[ 'success' ])
          return response;
        else
          return null;
      })
      .catch(error => {
        return null;
      });
  }

  saveSingleIndicatorData(cityId: string, year: string, data: any): Promise<any> {
    return this.http.post(`${environment.apiURL}/restricted/cityProfile/saveIndicatorSingleItem/${cityId}/${year}`, data)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  deleteSingleIndicatorData(cityId: string, year: string, data: any): Promise<any> {
    return this.http.post(`${environment.apiURL}/restricted/removeIndicatorSingleItem/${cityId}/${year}`, data)
      .toPromise()
      .then(response => {
        if (response[ 'success' ])
          return response;
        else
          return null;
      })
      .catch(error => {
        return null;
      });
  }

  saveIndicatorYear(cityId: string, data?: any): Promise<any> {
    return this.http.post(`${environment.apiURL}/restricted/cityProfile/saveIndicatorYear/${cityId}`, data)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  saveCityProfileIndicatorYear(cityId: string, data?: any): Promise<any> {
    return this.http.post(`${environment.apiURL}/restricted/cityProfile/saveCityPofileYear/${cityId}`, data)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  getRoadmapData(cityId: string): Promise<any> {
    return this.http.get(environment.apiURL + '/restricted/cityProfile/solutionsRoadmap/' + cityId)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  saveCityProfileIndicatorFullYear(cityId: string, year: string, data: any): Promise<any> {
    return this.http.post(`${environment.apiURL}/restricted/cityProfile/saveProfileFullYear/${cityId}/${year}`, data)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  saveIndicatorFullYear(cityId: string, year: string, data: any): Promise<any> {
    return this.http.post(`${environment.apiURL}/restricted/cityProfile/saveIndicatorsFullYear/${cityId}/${year}`, data)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  getSolutionImpact(userId: string, cityId: string): Promise<any> {
    return this.http.get(environment.apiURL + '/restricted/supplier/impacts/' + userId + '/' + cityId)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      })
  }

  getSolutionList(userId: string, cityId: string): Promise<any> {
    return this.http.get(environment.apiURL + '/restricted/supplier/solutionImpacts/' + userId + '/' + cityId)
      .toPromise()
      .then(response => {
        return response
      })
      .catch(error => {
        return null
      })
  }

  //LEGADO
  getBenchmarksIndicator(cityId: string, data: IndicatorSearchFilter): Promise<any> {
    return this.http.post(environment.apiURL + '/admin/city/indicatorHistory/' + cityId, data)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  getSolutionsToImproveCity(cityId: string, amount: number): Promise<SolutionPerCityIndicator[]> {

    var header = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this.authService.accessToken}`)
    }

    return this.http.get(environment.apiURL + '/dashboard/cityImprovementForWorstAreas/' + cityId + '/' + amount, header)
      .toPromise()
      .then(response => {
        return response as SolutionPerCityIndicator[];
      })
      .catch(error => {
        return null;
      });
  }

  getCityProfileIndicators(id: string): Promise<any> {

    var header = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this.authService.accessToken}`)
    }

    return this.http.get(environment.apiURL + '/restricted/cityProfileIndicators/' + id, header)
      .toPromise()
      .then(response => {
        return response as SolutionPerCityIndicator[];
      })
      .catch(error => {
        return null;
      });
  }

  getGlobalBenchmarks(): Promise<GlobalBenchmarkCity[]> {

    var header = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this.authService.accessToken}`)
    }

    return this.http.get(environment.apiURL + '/restricted/cityGlobalBenchmarks', header)
      .toPromise()
      .then(response => {
        return response as GlobalBenchmarkCity[];
      })
      .catch(error => {
        return null;
      });
  }

  getSolutions(city: string) {

    var header = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this.authService.accessToken}`)
    }

    return this.http.get(environment.apiURL + '/dashboard/recomendedSolutions/' + city + '/4', header)
      .toPromise()
      .then(response => {
        return response as GlobalBenchmarkCity[];
      })
      .catch(error => {
        return null;
      });
  }

  getNewCityProfile(id: string): Promise<any> {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this.authService.accessToken}`)
    }

    return this.http.get(environment.apiURL + '/restricted/cityProfileHelper/' + id, header)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        console.log(`Error: getNewCityProfile`);
        return null;
      });
  }

  getCityRanking(id: string): Promise<any> {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this.authService.accessToken}`)
    }

    return this.http.get(environment.apiURL + '/restricted/cityBenchmarksRanking/' + id, header)
      .toPromise()
      .then(response => {
        // console.log(`getCityRanking: ${JSON.stringify(response)}`);
        return response;
      })
      .catch(error => {
        console.log(`Error: getCityRanking`);
        return null;
      });
  }

  getCityBenchmarks(id: string): Promise<any> {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this.authService.accessToken}`)
    }

    return this.http.get(environment.apiURL + '/restricted/cityBenchmarks/' + id, header)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        console.log(`Error: getCityBenchmarks`);
        return null;
      });
  }

  getCityBenchmarksArea(id: string, area: string): Promise<any> {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this.authService.accessToken}`)
    }

    return this.http.get(`${environment.apiURL}/restricted/cityProfile/benchmarksArea/${id}/${area}`, header)
      //return this.http.get(`${environment.apiURL}/restricted/cityBenchmarksArea/${id}/${area}`, header)
      .toPromise()
      .then(response => {
        // console.log(`getCityBenchmarksArea: ${JSON.stringify(response)}`);
        return response;
      })
      .catch(error => {
        console.log(`Error: getCityBenchmarksArea`);
        return null;
      });
  }

  getCityIndicatorsArea(id: string, area: string): Promise<any> {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this.authService.accessToken}`)
    }

    return this.http.get(`${environment.apiURL}/restricted/cityIndicators/${id}/${area}`, header)
      .toPromise()
      .then(response => {
        // console.log(`getCityIndicatorsArea: ${JSON.stringify(response)}`);
        return response;
      })
      .catch(error => {
        console.log(`Error: getCityIndicatorsArea`);
        return null;
      });
  }

  getCityRankingArea(id: string, area: string): Promise<any> {
    // console.log(` getCityRankingArea id:${id} area:${area}`);
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this.authService.accessToken}`)
    }

    return this.http.get(`${environment.apiURL}/restricted/cityProfile/globalRankingArea/${id}/${area}`, header)
      // return this.http.get(`${environment.apiURL}/restricted/cityBenchmarksRankingArea/${id}/${area}`, header)
      .toPromise()
      .then(response => {
        // console.log(`getCityRankingArea: ${JSON.stringify(response)}`);
        return response;
      })
      .catch(error => {
        console.log(`Error: getCityRankingArea`);
        return null;
      });
  }

  getCityProfileIndicatorArea(id: string, area: string): Promise<any> {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this.authService.accessToken}`)
    }

    return this.http.get(`${environment.apiURL}/restricted/cityBenchmarksIndicatorsArea/${id}/${area}`, header)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        console.log(`Error: getCityProfileIndicatorArea`);
        return null;
      });
  }

  getCertifications(): Observable<Certification[]> {
    return this.http.get<Certification[]>(`${environment.apiURL}/certifications`);
  }

  getCityCertification(cityId: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiURL}/cityCertification/${cityId}`);
  }

  createCityCertification(cityId: string, certificationId: string): Observable<CityCertification> {
    return this.http.post<CityCertification>(`${environment.apiURL}/cityCertification/${cityId}/certification/${certificationId}`, {});
  }

  getCityCertificationResume(cityCertificationId: string, year: number): Observable<CityCertificationResume> {
  return this.http.get<CityCertificationResume>(`${environment.apiURL}/cityCertification/${cityCertificationId}/resume?year=${year}`);
  }

  getCityCertificationByArea(cityCertificationId: string, certificationArea: string, year: number): Observable<any> {
    return this.http.get<any>(`${environment.apiURL}/cityCertification/${cityCertificationId}/area/${certificationArea}/indicators?year=${year}`);
  }

  public async getPreSignedModelDownload(cityCertificationId: string, indicatorId: string): Promise<string> {
    const url = `${environment.apiURL}/cityCertification/${cityCertificationId}/indicator/${indicatorId}/evidence-model/pre-signed-url`;
    const download$ = this.http.get(url, { responseType: 'text' });
    return await download$.toPromise()
      .then((data) => {
        return this.mapperModelDownload(data);
      })
      .catch((error) => {
        throw new HttpErrorResponse(error);
      })
  }

  saveCertificationIndicator(indicator: any, cityCertificationId: string, indicatorId: string): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/cityCertification/${cityCertificationId}/indicator/${indicatorId}`, { ...indicator });
  }

  saveCertificationIndicatorAbnt(indicator: any, cityCertificationId: string, indicatorId: string): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}/cityCertification/${cityCertificationId}/indicator/${indicatorId}/abnt-update`, { ...indicator });
  }

  uploadEvidence(file: File, cityCertification: string, certificationArea: string): Observable<any> {
    const body = new FormData()
    body.append('file', file);

    return this.http.post(`${environment.apiURL}/cityCertification/${cityCertification}/area/${certificationArea}/evidence`, body, { responseType: 'text' });
  }

  getCityPopulationalBenchmarks(cityId: string): Observable<any> {
    return this.http.get<any>(`${environment.apiURL}/restricted/cityPopulationalBenchmarks/${cityId}`);
  }

  getPrivateEvidenceUrl(evidence, cityCertification: string, certificationArea: string): Observable<any> {
    return this.http.post(`${environment.apiURL}/cityCertification/${cityCertification}/area/${certificationArea}/evidence/pre-signed-url`, evidence, { responseType: 'text' });
  }

  exportSolutionsRoadmap(cityId: string): Observable<any> {
    return this.http.get(
      `${environment.apiURL}/restricted/cityProfile/exportSolutionsRoadmap/${cityId}`,
      { responseType: 'blob' }
    );
  }

  exportIndicators(cityId: string, filter): Observable<any> {
    return this.http.post(
      `${environment.apiURL}/restricted/exportIndicators/${cityId}`,
      { ...filter },
      { responseType: 'blob' }
    );
  }

  private mapperModelDownload(download$: string): string {
    return download$
  }

  public removeEvidence(evidenceId: number, indicatorId: string, cityCertificationId: string, year: number): Observable<any> {
    return this.http.delete(`${environment.apiURL}/cityCertification/${cityCertificationId}/indicator/${indicatorId}/evidence/${evidenceId}/${year}`);
  }

  public submitEvidence(evidence: {abntId: string, file?: File, description: string, link?: string}, evidenceType: EvidenceAbntType, indicatorId: string, cityCertificationId: string, year: number): Observable<any> {

    const formEvidence = new FormData();
    formEvidence.append('file', evidence.file);
    formEvidence.append('link', evidence.link);
    formEvidence.append('description', evidence.description);
    if (evidence.abntId) {
      formEvidence.append('abntId', evidence.abntId);
    }
    formEvidence.append('year', year.toString());
    
    return this.http.post(`${environment.apiURL}/cityCertification/${cityCertificationId}/indicator/${indicatorId}/evidence/${evidenceType}`, formEvidence);
  }

}
